import React from 'react';

// The app's starfield (style/parallax-star.css), brought back and wired to the
// room's volume.
//
// That stylesheet has been dead code since the mobile performance pass: it
// still ships ~2000 box-shadows across three parallax layers, but nothing has
// rendered the #stars elements it styles. The art was already paid for; this
// is where it earns its place.
//
// `energy` (0..1, see useRoomEnergy) feeds a CSS variable rather than driving
// anything in JS - the layers keep their own long CSS animations and only
// their brightness responds, so a lively discussion lifts the backdrop and a
// quiet room lets it settle, without a render per frame.
//
// Not rendered at all when the active theme has animated backgrounds turned
// off, or on a phone - which is the condition the starfield was removed under
// in the first place, and the one promise this revival has to keep.
export default function MeetingStarfield({ energy }) {
    return (
        <div className="MeetStarfield" style={{ '--meet-energy': energy }} aria-hidden="true">
            {/* Three layers at different sizes and speeds - that parallax is
                the whole effect, and each id carries its own box-shadow set. */}
            <div id="stars" />
            <div id="stars2" />
            <div id="stars3" />
        </div>
    );
}
